import { Avatar, Button, ClickAwayListener, Grow, ListItemIcon, ListItemText, makeStyles, MenuItem, MenuList, Paper, Popper } from '@material-ui/core';
import React, { useState } from 'react';
import {useGoogleLogin, useGoogleLogout } from 'react-google-login'
import { AccountCircle, ExitToApp } from '@material-ui/icons';
import Icon from '@material-ui/core/Icon';


const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
    },
    paper: {
      marginRight: theme.spacing(2),
    },
    signIn : {
        fontSize : '1.5rem !important',
        marginTop : '2vh', 
        color:'#e5e7eb ',
        textTransform: 'none',
        '&:hover' : {
            color : '#fe752f'
        },
        '&:hover .MuiIcon-root' : {
            color : '#fe752f'
        },
    },
    avatar : {
        marginTop : '2vh', 
    },
    svg : {
        width: '1.5em !important',
            height : '1.5em !important',
        color : '#e5e7eb',
        "& .MuiIcon-root" : {
            width: '1.5em !important',
            height : '1.5em !important',
            color : '#e5e7eb',
        },
    },
    menu : {
        backgroundColor: '#373737', 
        color: '#e5e7eb'
    },
    signout: {
        fontSize : '1.5rem !important',
        color : '#e5e7eb',
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#e5e7eb',
        }
    }
  }));

const clientId = "1046785123269-gg6ob1gdpql3nfdd9h9ispclce9b8ipj.apps.googleusercontent.com";
export default function LoginComponent() {

    const classes = useStyles();
    let status;
    if(localStorage.getItem("auth")){
        if (JSON.parse(localStorage.getItem("auth")).ttl > +new Date){
            status = true;
        } else{
            status = false;
        }    
    } else {
        status = false
    }
    const [signStatus, setSign] = useState(status);
    const [hover, setHover] = useState(false);


    const onSuccess = (res) => {
        let obj = res.profileObj;
        obj.ttl = (+new Date + 1296000);
        localStorage.setItem("auth",JSON.stringify(obj));
        setSign(true)
    }
    const onFailure = (res) => {
        localStorage.removeItem("auth")
    }
    const onLogoutSuccess = (suc) => {
        localStorage.removeItem("auth");
        setSign(false)
    }
    
    const { signIn } = useGoogleLogin({
        onSuccess,
        clientId,
        onFailure,
        cookiePolicy:'single_host_origin'
    })
    
    const { signOut } = useGoogleLogout({
    onLogoutSuccess,
    clientId,
    })

    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
        return;
        }

        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
        event.preventDefault();
        setOpen(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
        anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);
        
        

    return(
        <div className="sign" >
            { signStatus ?
                <Avatar 
                alt="signed-in"
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                src={JSON.parse(localStorage.getItem("auth")).imageUrl}
                onClick={handleToggle}
                classes={{ root : classes.avatar }}
                >
                    <AccountCircle />
                </Avatar> 
                 :
                 <Button
                 onMouseEnter={() => setHover(true)}
                 onMouseLeave={() => setHover(false)}
                onClick={signIn}
                classes = {{ root : classes.signIn }}
                startIcon={
                    <Icon classes={{ root : classes.svg }} >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" className={(hover)?"GSvgHover":"GSvg"} ><path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z"></path></svg>
                    </Icon>
                }
                >
                    Sign In
                </Button> 
             }
            <Popper placement="bottom-end" open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
              {({ TransitionProps, placement }) => (
                <Grow
                {...TransitionProps}
                style={{ transformOrigin: 'top right', anchorOrigin : 'left-end', top:'0',left:'50px' }}
                >
                    <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                        <MenuList classes={{root:classes.menu}} autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                            <MenuItem onClick={(e)=>{ signOut(); handleClose(e); }}>
                                <ListItemIcon classes={{root: classes.signout}}>
                                    <ExitToApp />
                                </ListItemIcon>
                                <ListItemText primary="Sign out" />
                            </MenuItem>
                        </MenuList>
                        </ClickAwayListener>
                    </Paper>
                 </Grow>
              )}
            </Popper>
      </div>
    )

}